<template>
    <div :data-field-group-name="data.visibility !== 'hidden' ? data.tag : ''">
        <div class="form-group" v-show="this.data.visibility !== 'hidden'">
            <label v-show="this.showLabel"> {{ label }} </label>
            <input v-model="value" :name="this.data.tag" type="hidden"/>
            <button v-if="value" @blur="onBlurToggle" @click.prevent="toggleDropdown" type="button" class="dropdown-toggle form-control">
                <div class="vti__flag-wrapper">
                    <span :class="['vti__flag', activeValueObject.iso2.toLowerCase()]"></span>
                </div>
                {{ activeValueObject.dialCode }}
            </button>
            <ul class="countries-dropdown" v-if="isOpen">
                <li v-for="c in countryOptions" @click.prevent="select(c)" :class="{'selected': value == c.value}">
                    <div class="vti__flag-wrapper">
                        <span :class="['vti__flag', c.iso2.toLowerCase()]"></span>
                    </div>
                    {{ c.name }}
                </li>
            </ul>
            <small style="width: 100%" class="form-text text-muted" v-show="data.help_text != ''">
                {{ data.help_text}}
            </small>
        </div>
    </div>
</template>

<script>
import countries from '../../../../assets/js/countries';
export default {
    name: 'PhonePrefixMailingboss',
    props: ['options', 'label', 'selected', 'data', 'multiple', 'showPlaceholder', 'showLabel'],
    data() {
        return {
            countries,
            value: this.selected,
            isOpen: false,
        }
    },
    mounted() {
        if (!this.selected)
        this.value = this.getDefaultValue()
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen
        },
        select(country) {
            this.value = country.value
            this.isOpen = false
        },
        onBlurToggle(event) {
            setTimeout(() => {
                this.isOpen = false
            }, 200)
        },
        getDefaultValue() {
            // 1 - field default value
            if (this.data.default_value) {
                return this.data.default_value
            }

            // 3 - browser
            const languageTag = navigator.language || navigator.userLanguage;
            const parts = languageTag.split('-');
            if (parts.length > 1) {
                const userIso = parts[parts.length - 1].toUpperCase();
                const optionValue = this.countryOptions.find(o => o.iso2 == userIso)
                if (optionValue)
                return optionValue.value
            }

            // 3 - first option
            if (this.countryOptions.length > 0) {
                return this.countryOptions[0].value
            }
            
            // 4 - USA
            return '1USA'
        }
    },
    computed: {
        placeholder() {
            return this.showPlaceholder ? this.label : ''
        },
        required() {
            return this.data.required === 'yes';
        },
        activeValueObject() {
            return this.countries.find(c => c.value == this.value)
        },
        countryOptions() {
            // mantem a ordenação do Mailingboss e remove os itens que o user removeu
            const array2Lookup = countries.reduce((map, obj) => {
                map.set(obj.value, obj.iso2);
                return map;
            }, new Map());
            return this.options
                .filter(item1 => array2Lookup.has(item1.value))
                .map(item1 => ({
                    ...item1,
                    // adiciona o iso2 (necessário pras bandeirinhas)
                    iso2: array2Lookup.get(item1.value)
                }));
        }
    }
}
</script>

<style lang="css">
@import '../../../../assets/css/flag-sprite.css';
</style>

<style lang="scss" scoped>
.dropdown-toggle {
    display: flex;
    align-items: center;
    gap: 3px;
}

.countries-dropdown {
    background-color: #fff;
    border: 1px solid rgba(206, 187, 187, 0.33);
    height: 300px;
    width: 280px;
    overflow-y: scroll;
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    z-index: 101;

    li {
        padding: 3px 8px;
        cursor: pointer;

        &:hover, &.selected {
            background-color: #eee;
        }
    }
}

.vti__flag-wrapper {
    display: inline-block;
    width: 20px;
    height: 12px;
    text-align: center;

    .vti__flag {
        width: 100%;
        height: 100%;
        display: block;
    }
}
</style>